
import SearchItemArea from '../../common/search/SearchItemArea';
import fetchWrapper from '../../helpers/fetchWrapper';
import { swalError } from '../../../app/helpers/swal';
import { Button, Form } from 'antd';
import { useHistory } from "react-router-dom";
import { useEffect, useRef, useState } from 'react';
import React from 'react';
export const DynamicFilter = (props) => {
	const { slug, currentComponent, moduleInfo, setModalConfig, mainData, setMainData, setCurrentComponent } = props;
	const [modData, setmodData] = useState([]);
	const [widgetFilterOpt] = useState({ option: [] });
	const [submitFlag, setSubmitFlag] = useState(false);
	const [modOptData, setmodOptData] = useState([]);
	const [searchSlug, setSearchSlug] = useState('');
	const _widgetFilterOpt = useRef(widgetFilterOpt);
	const ref = useRef();
	const [form] = Form.useForm();
	const history = useHistory();

	const _setWidgetFilterOpt = (value) => {
		_widgetFilterOpt.current.option = value;
	};

	useEffect(() => {
		setSearchSlug(slug);
	}, [slug]);
	const searchFilter = async (e) => {
		if (submitFlag) {
			const payload = {
				module_id: 22,
				widget_id: currentComponent.dashboard_widget_id,
				dnd_layout_config: currentComponent.dnd_layout_config,
			};
			payload.search_option =
				_widgetFilterOpt.current.option.length > 0 ? JSON.stringify(_widgetFilterOpt.current.option) : '';
			payload.search_data = e;
			await fetchWrapper
				.post('/dashboard/widget/single-widget', payload)
				.then((response) => {
					if (!response?.error) {
						setCurrentComponent(response.data);
						const newMainData = [...mainData].map((item) =>
							item.dashboard_widget_id === response.data[0].dashboard_widget_id ? response.data[0] : item,
						);

						setMainData(newMainData);
						setModalConfig({ isModalOpen: false });

						history.push({
							pathname: `/`,
						});
					} else {
						swalError(response?.error?.message);
					}
				})
				.catch((error) => {
					console.log(error?.message);
					swalError(error?.message);
				});
		}
	};
	const getActiveFieldIds = (e) => {
		_setWidgetFilterOpt(e);
	};
	const handleSubmit = async () => {
		setSubmitFlag(true);
		if (ref.current.filter()) {
			ref.current.filter();
		} else {
			searchFilter();
		}
	};
	useEffect(() => {
		if (currentComponent) {
			const parseData = JSON.parse(currentComponent?.search_column);
			const parseOptData = JSON.parse(currentComponent?.search_option);
			_setWidgetFilterOpt((prev) => ({ ...prev, option: parseOptData }));
			const modNewData =
				parseData?.length > 0 &&
				parseData?.map((item) => ({
					...item,
					name: item.name.split('-')?.splice(-1)?.[0],
				}));
			const getFilterValue = [];
			// modNewData?.length > 0 &&
			// 	modNewData?.map((item) => {
			// 		getFilterValue.push({ [item.name]: item.value });
			// 	});
			setmodData(getFilterValue);
			const result = parseOptData?.map(function (x) {
				return String(x);
			});
			setmodOptData(result);
		}
	}, []);

	return (
		<div>
			{/* <p>Some widgets show task data over time, while others act as a snapshot of the current moment.</p>
			<p>
				Time-based widgets will show the tasks you are filtering for and the history of those tasks, not the
				snapshots of tasks that previously met your criteria.   onFinish={searchFilter}
			</p> */}
			<Form form={form} layout="vertical">
				{searchSlug && (
					<SearchItemArea
						slug={searchSlug}
						handleSearch={searchFilter}
						getActiveFieldIds={getActiveFieldIds}
						defaultSearchItems={modOptData}
						searchRef={ref}
						showFilterBtn={false}
						defaultSearchValues={modData}
					/>
				)}
				<Button type="primary" onClick={handleSubmit} className="mt-2">
					Add Filter
				</Button>
			</Form>
		</div>
	);
};
